import { makeStyles } from "@material-ui/styles";

export const styleCollective = makeStyles((theme) => ({
    buttonSearch: {
      color: "#ffffff",
      background: "#7EBDCE",
      "&:hover": { color: "white", background: "#099F9F" },
    },
    buttonClear: {
        color: "#666666",
        width: 100,
        border: "solid 1px",
        background: "#ffffff",
        "&:hover": { color: "#099F9F", background: "#ffffff" },
    },
    menuItem: {
        textAlign: 'start',
        "&:hover": {
        borderLeft: "4px solid #098B8B",
        },
    },
    inputForm: {
        backgroundColor: "#FFFFFF",
        boxSizing: "border-box",
        borderRadius: "8px",
        height: 40,
        fontSize: "14px",
        textAlign: 'start',
        [`& fieldset`]: {
        borderRadius: 8,
        fontSize: 14,
        },
    },
    contFormSearch:{
        width: '100%',
        marginTop: '50px',
        marginBottom: '40px'
    },
    column: {
        flexBasis: "39.6%",
        marginRight: '10px',
    },
    heading: {
        fontSize: theme.typography.pxToRem(12),
        wordBreak: 'normal',
    },
    secondaryHeading: {
        fontSize: theme.typography.pxToRem(12),
        color: theme.palette.text.secondary,
        wordBreak: 'normal'
    },
    contIconDownload:{
        width: 100,
    },
    iconEvent:{
        pointerEvents: 'auto',
        color: '#099F9F'
    },
    cardSerColectivo:{
        position: "relative",
        width: '80%',
        minHeight:'300px',
        backgroundColor: theme.palette.background.paper,
        boxShadow: "0px 0px 8px rgba(0, 0, 0, 0.24)",
        outline: "none",
        borderRadius: 8,
        padding: theme.spacing(2, 2, 2),
      },
      title: {
        fontFamily: "Roboto",
        fontSize: 24,
        fontStyle: "normal",
        fontWeight: 'normal',
        letterSpacing: "0em",
        textAlign: "center",
        marginBottom: 30
      },
      contAccordion:{
        width: '100%',
        marginTop: '20px !important',
      },
      scrollBars:{
        width: '100%',
        height: 200,
        backgroundColor: "#ffffff",
        position: "sticky",
      },
      paperdos:{
        width:'100%',
        height: 220,
        borderRadius: 5,
      },
      contBtnSubmit:{
        marginTop: 15,
      },
}))